/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account
 */

import Transformer from './transformer';

export default class CoursesTransformer extends Transformer {
  // sorts list of classes by created timestamp
  static orderbycreated(list) {
    return list.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  }

  // fetches list of courses
  static fetch(courses) {
    return this.orderbycreated(courses);
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/courses.js